import React from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import Loader from "../common/loader.jsx";
import axios from "../requests/axios.js";

export default function ImageUpload({ onSuccess, meta, endpoint, children }) {
  const [file, setFile] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const uploadImage = React.useCallback(
    async (imageFile) => {
      setLoading(true);

      const formData = new FormData();
      formData.append("image", imageFile); // Change 'image' to match Laravel's expected field name

      try {
        const response = await axios.post(endpoint, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        return response.data?.url;
      } catch (err) {
        console.error("Upload error:", err);
      } finally {
        setLoading(false);
      }
    },
    [endpoint],
  );

  const onDrop = React.useCallback(
    (acceptedFiles) => {
      const imageFile = acceptedFiles[0];
      if (imageFile) {
        setFile(imageFile);
        uploadImage(imageFile)
          .then((image) => {
            onSuccess(image, meta);
          })
          .catch(console.error);
      }
    },
    [onSuccess, meta, uploadImage],
  );

  return (
    <Dropzone onDrop={onDrop} accept={{ "image/*": [] }} multiple={false}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div className="upload" {...getRootProps()}>
          <input {...getInputProps()} className="upload__input" />
          {loading ? (
            <div className="upload__loader">
              <Loader />
            </div>
          ) : (
            <div className={`upload__message ${isDragActive ? "upload__message--active" : ""}`}>{children}</div>
          )}
        </div>
      )}
    </Dropzone>
  );
}
